// extracted by mini-css-extract-plugin
module.exports = {"hireService__text":"AdsMessageDialog_hireService__text__qJHKd","ads-instant-match-buttons__chat":"AdsMessageDialog_ads-instant-match-buttons__chat__OoQgA"};